exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dragme {\n  background: #2c7ad0;\n  color: #fff;\n  padding: 10px;\n  display: block;\n  float: left;\n  margin: 10px;\n  border-radius: 5px;\n}\n\n", ""]);

// exports
